export default __webpack_public_path__ + "static/media/cloves.1b6b9c3e.jpg";